import z from "zod";
import { MoneyScheme } from "./money";
import { Currency } from "./enums/currency";

export const MultiCurrencyMoneyScheme = z.object({
  currencies: z
    .object({
      [Currency.SEK]: MoneyScheme.optional(),
      [Currency.EUR]: MoneyScheme.optional(),
    })
    .partial(),
});

export type MultiCurrencyMoney = z.infer<typeof MultiCurrencyMoneyScheme>;
